import React from 'react';
import { Box, Card, CardContent, Chip, Container, Stack, Typography } from '@mui/material';

const values = [
  {
    title: 'Missao',
    text: 'Transformar desafios complexos em solucoes digitais de alto impacto, unindo engenharia, ciencia de dados e execucao orientada a resultado.'
  },
  {
    title: 'Visao',
    text: 'Ser referencia em inteligencia digital aplicada, ampliando a capacidade de decisao e inovacao de organizacoes publicas e privadas.'
  },
  {
    title: 'Valores',
    text: 'Integridade, excelencia tecnica, colaboracao, foco no cliente e compromisso com impacto real e sustentavel.'
  }
];

const pillars = [
  'Metodo e disciplina de execucao',
  'Arquitetura e engenharia de qualidade',
  'Inovacao orientada por evidencia',
  'Velocidade com governanca e seguranca'
];

const PurposeMobile = () => {
  return (
    <Box sx={{ bgcolor: '#050505', color: '#fff', minHeight: '100%' }}>
      <Box sx={{ pt: 4, pb: 3, borderBottom: '1px solid #1f1f1f' }}>
        <Container maxWidth="sm" sx={{ px: 2 }}>
          <Typography variant="overline" sx={{ color: '#b0b0b0', letterSpacing: '0.18em' }}>
            PROPOSITO
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 900, lineHeight: 1.05, mt: 1 }}>
            Missao e Valores
          </Typography>
          <Typography variant="body2" sx={{ color: '#c8c8c8', mt: 1.5, lineHeight: 1.65 }}>
            Inteligencia Digital para transformar contexto em decisao, decisao em execucao e execucao em resultado.
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="sm" sx={{ px: 2, py: 2.5 }}>
        <Stack spacing={1.5}>
          {values.map((item) => (
            <Card key={item.title} sx={{ bgcolor: '#101010', border: '1px solid #252525' }}>
              <CardContent sx={{ p: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 800, mb: 1 }}>
                  {item.title}
                </Typography>
                <Typography variant="body2" sx={{ color: '#d3d3d3', lineHeight: 1.65 }}>
                  {item.text}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Stack>

        <Box sx={{ mt: 2.5, p: 2, bgcolor: '#111', border: '1px solid #252525', borderRadius: 2 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1.2 }}>
            Pilares de Execucao
          </Typography>
          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
            {pillars.map((pillar) => (
              <Chip key={pillar} label={pillar} size="small" sx={{ bgcolor: '#1f1f1f', color: '#f0f0f0', borderRadius: 1 }} />
            ))}
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default PurposeMobile;
